import { render, staticRenderFns } from "./My.vue?vue&type=template&id=a3070dba&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&id=a3070dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3070dba",
  null
  
)

export default component.exports